import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    saveParams: String,
    resetParams: String,
    allowedParams: Array,
    userId: Number
  }

  static targets = ["field"]

  connect() {
    if (this.hasResetParamsValue) {
      this.clear(this.resetParamsValue)
    }

    if (this.hasSaveParamsValue && this.hasAllowedParamsValue) {
      this.saveSearchParams(this.saveParamsValue, this.allowedParamsValue)
    }

    this.updateDynamicBackLinks()
    this.populateHiddenField()
  }

  save(key, params) {
    const payload = {
      data: { ...params, user_id: this.userIdValue },
      saved_at: Date.now()
    }
    localStorage.setItem(key, JSON.stringify(payload))
  }

  load(key, currentUserId = this.userIdValue) {
    const raw = localStorage.getItem(key)
    if (!raw) return null

    try {
      const parsed = JSON.parse(raw)
      const maxAge = 60 * 60 * 1000 // 1h

      if (
        Date.now() - parsed.saved_at < maxAge &&
        parsed.data.user_id === currentUserId
      ) {
        // pomijamy user_id
        const { user_id: _userId, ...filteredData } = parsed.data
        return filteredData
      } else {
        localStorage.removeItem(key)
        return null
      }
    } catch (e) {
      localStorage.removeItem(key)
      return null
    }
  }

  clear(key) {
    localStorage.removeItem(key)
  }

  buildSearchParams(data) {
    const params = new URLSearchParams()

    for (const key in data) {
      const value = data[key]
      if (Array.isArray(value)) {
        value.forEach((item) => {
          params.append(`${key}[]`, item)
        })
      } else {
        params.append(key, value)
      }
    }

    return params.toString()
  }

  saveSearchParams(key, allowedKeys = []) {
    const urlParams = new URLSearchParams(window.location.search)
    const params = {}

    for (const [rawKey, value] of urlParams.entries()) {
      if (value.trim() === "") continue
      // tablicowe parametry mają dołożone nawiasy po zdekodowaniu np.: kinds[]
      const isArrayParam = /\[\]$/.test(rawKey)
      const cleanedKey = rawKey.replace(/\[\]$/, '')
      if (!allowedKeys.length || allowedKeys.includes(cleanedKey)) {
        if (params[cleanedKey] === undefined) {
          params[cleanedKey] = isArrayParam ? [value] : value
        } else {
          if (Array.isArray(params[cleanedKey])) {
            params[cleanedKey].push(value)
          }
        }
      }
    }

    const isPageEmpty = !urlParams.get("page")?.trim()
    const isPageAllowed = !allowedKeys.length || allowedKeys.includes("page")

    if (isPageEmpty && isPageAllowed) {
      params.page = 1
    }

    if (Object.keys(params).length > 0) {
      this.save(key, params)
    } else {
      this.clear(key)
    }
  }

  updateDynamicBackLinks() {
    const links = document.querySelectorAll('[data-dynamic-back]')

    links.forEach(link => {
      const key = link.dataset.searchKey
      const data = this.load(key, Number(link.dataset.userId))

      if (key && data) {
        try {
          const params = this.buildSearchParams(data).toString()
          const baseUrl = link.getAttribute("href").split("?")[0]
          link.setAttribute("href", `${baseUrl}?${params}`)
        } catch (e) {
          console.error("Błąd przy odczycie localStorage:", e)
        }
      }
    })
  }

  populateHiddenField() {
    if (!this.hasFieldTarget || !this.hasSaveParamsValue) return

    const data = this.load(this.saveParamsValue, this.userId)
    if (data) {
      this.fieldTarget.value = new URLSearchParams(data).toString()
    }
  }
}
